export default __webpack_public_path__ + "static/media/fm.9f8fd0b5.svg";